export function VideoLoadingState() {
    return (
        <div className="flex items-center justify-center w-full h-full bg-black-100">
            <div className="text-grey-300">Loading...</div>
        </div>
    );
}
